export const COLORS = {
  primary: "#00444C",
  secondary: "#009687",
  green: "#16a34a",
  blue: "#2563eb",
  amber: "#d97706",
  muted: "#94a3b8",
};

export const STATUS_COLORS: Record<string, string> = {
  draft: COLORS.amber,
  complete: COLORS.blue,
  finalized: COLORS.green,
};

export function formatRelativeTime(date: string | number): string {
  const diffMs = Date.now() - (typeof date === "number" ? date : new Date(date).getTime());
  const diffMins = Math.floor(diffMs / 60000);
  if (diffMins < 1) return "just now";
  if (diffMins < 60) return `${diffMins}m ago`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours}h ago`;
  const diffDays = Math.floor(diffHours / 24);
  return `${diffDays}d ago`;
}

export function formatMonth(month: string): string {
  const [year, m] = month.split("-");
  const date = new Date(Number(year), Number(m) - 1);
  return date.toLocaleDateString("en-US", { month: "short", year: "2-digit" });
}
